import { NavigationClient } from '@azure/msal-browser'

// Routes MSAL's internal navigations (e.g. landing back on the app after a
// redirect) through vue-router instead of a full page reload.
export class RouterNavigationClient extends NavigationClient {
  constructor (router) {
    super()
    this.router = router
  }

  async navigateInternal (url, options) {
    const relativePath = url.replace(window.location.origin, '')
    if (options.noHistory) {
      this.router.replace(relativePath)
    } else {
      this.router.push(relativePath)
    }
    return false
  }
}
